package co.maytes.standupbot.dashboard.features.teams

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.dashboard.stores.rememberApiClient
import co.maytes.standupbot.shared.dto.team.TeamDto
import co.maytes.standupbot.shared.dto.team.UpsertTeamRequestDto

enum class TeamsListPhase { Idle, Loading, Ready, Failed }

class TeamsStore(private val api: ApiClient) {
    var list: List<TeamDto> by mutableStateOf(emptyList())
        private set

    var phase: TeamsListPhase by mutableStateOf(TeamsListPhase.Idle)
        private set

    var lastError: String? by mutableStateOf(null)
        private set

    suspend fun refresh(workspaceId: String): Result<List<TeamDto>, ApiError> {
        phase = TeamsListPhase.Loading
        val res = api.get<List<TeamDto>>("/api/v1/workspaces/$workspaceId/org-teams")
        when (res) {
            is Result.Ok -> {
                list = res.value
                lastError = null
                phase = TeamsListPhase.Ready
            }
            is Result.Err -> {
                lastError = res.error.displayMessage
                phase = TeamsListPhase.Failed
            }
        }
        return res
    }

    suspend fun create(workspaceId: String, body: UpsertTeamRequestDto): Result<TeamDto, ApiError> =
        api.post("/api/v1/workspaces/$workspaceId/org-teams", body)

    suspend fun update(workspaceId: String, teamId: String, body: UpsertTeamRequestDto): Result<TeamDto, ApiError> =
        api.put("/api/v1/workspaces/$workspaceId/org-teams/$teamId", body)

    suspend fun delete(workspaceId: String, teamId: String): Result<Unit, ApiError> =
        api.delete("/api/v1/workspaces/$workspaceId/org-teams/$teamId")
}

@Composable
fun rememberTeamsStore(): TeamsStore {
    val api = rememberApiClient()
    return remember(api) { TeamsStore(api) }
}
